import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../common/breadcrumb';
// import data from '../../assets/data/sales-transactions';
// import Datatable from '../common/datatable';
import VerDetailsOrderDatatable from '../common/ver-details-order-datatable';
import AuthService from '../services/auth.service';
import ApiService from '../services/api.service';
//import { ToastContainer, toast } from 'react-toastify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import Modal from 'react-responsive-modal';
import Moment from 'moment';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import CheckButton from 'react-validation/build/button';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import { roundNumber } from '../roundNumber';
import { SortableTh, sortRows, nextSort } from '../common/sortable-th';
registerLocale('es', es);

const DEBTOR_AVATAR_COLORS = ['#27ae60', '#0d6efd', '#e67e22', '#8e44ad', '#e4566e'];

function initials(name, lastName) {
  return ((name || '').charAt(0) + (lastName || '').charAt(0)).toUpperCase() || '?';
}

// Mismos colores/estilo que ya usamos en /orders (ver-order-list.js)
const STATUS_CHARGE_MAP = {
  'POR COBRAR': { label: 'Por cobrar', bg: '#fff3cd', color: '#856404' },
  CANCELADO: { label: 'Cancelado', bg: '#f8d7da', color: '#721c24' },
  PAGADO: { label: 'Pagado', bg: '#d4edda', color: '#155724' },
  PARCIAL: { label: 'Parcial', bg: '#cce5ff', color: '#004085' },
};

function ChargeStatusBadge({ status }) {
  const s = STATUS_CHARGE_MAP[status] || { label: status || '—', bg: '#e9ecef', color: '#495057' };
  return (
    <span style={{ background: s.bg, color: s.color, borderRadius: 10, padding: '2px 9px', fontSize: 12, fontWeight: 600 }}>
      {s.label}
    </span>
  );
}

function fmtMoney(val) {
  if (val === null || val === undefined || val === '') return '—';
  return 'S/ ' + parseFloat(val).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Este campo es obligatorio!
      </div>
    );
  }
};

export class VerCollectionList extends Component {
  constructor(props) {
    super(props);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handlerAcept = this.handlerAcept.bind(this);
    this.handlerCancel = this.handlerCancel.bind(this);
    this.handlerDetails = this.handlerDetails.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onChangeReference = this.onChangeReference.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.handleCollectionsSort = this.handleCollectionsSort.bind(this);
    this.state = {
      openModal: false,
      loadingTable: true,
      dataCateg: [],
      results: [],
      detailResults: [],
      client: '',
      state: '',
      date: '',
      hour: '',
      id_order: null,
      total_order: null,
      address: '',
      district: '',
      interior: '',
      url_google: '',
      cash: 0,
      delivery: 0,
      total_payment: 0,
      pending_payment: 0,
      temp: [],
      total: 0,
      totalUsuarios: [],
      errors: {},
      reference: '',
      value: 0,
      id_address: null,
      paymentDate: new Date(),
      file_image: null,
      voucher_image: '',
      collectionsPage: 1,
      collectionsSort: { key: null, dir: 'asc' },
    };
  }

  handleCollectionsSort(key) {
    this.setState((prev) => ({
      collectionsSort: nextSort(prev.collectionsSort, key),
      collectionsPage: 1,
    }));
  }

  handleChange(date) {
    this.setState({
      paymentDate: date,
    });
  }

  componentWillMount() {
    this.getDataCollections();
  }

  onChangeReference(e) {
    this.setState({
      reference: e.target.value,
    });
  }

  onChangeValue(e) {
    this.setState({
      value: e.target.value,
    });
  }

  onChangeFilter(e) {
    this.setState(
      {
        filter: e.target.value,
      },
      function () {
      }
    );

    const val = e.target.value.toLowerCase();
    if (this.state.temp.length != 0) {
      var columns = Object.keys(this.state.temp[0]);
      //Los botones de acciones se pintan despues
      columns.splice(columns.length);
      //columns.splice(columns.length - 1);

      if (!columns.length) return;
      const rows = this.state.temp.filter(function (d) {
        for (let i = 0; i <= columns.length; i++) {
          let column = columns[i];
          if (
            d[column] &&
            d[column].toString().toLowerCase().indexOf(val) > -1
          ) {
            return true;
          }
        }
      });
      this.setState(
        {
          results: rows,
        },
        function () {
          this.renderResults(this.state.results.length);
        }
      );
      /*this.Inventarios = rows;
          let articulosAlmacenes;
          articulosAlmacenes = { 'Articulos': this.Inventarios }
          this.buildpurchaseForm(articulosAlmacenes);*/
    }

    e.preventDefault();
  }

  getDataCollections() {
    var user = AuthService.getCurrentUser();
    ApiService.getPurchaseCharge(user.token).then(
      (res) => {
        if (res && res.status == 'success') {
          const items = res.data.map(function (row) {
            return {
              Id: row.id,
              id_user: row.id_user,
              Usuario: row.User.name + ' ' + row.User.last_name,
              Embajador: row.Referred && row.Referred.name?row.Referred.name + ' ' + row.Referred.last_name:'',
              Fecha: row.date_programmed,
              'Estado Cobranza': row.status_charge,
              Delivery: row.delivery,
              Total: row.totalOrder,
              Cash: row.cash,
              'Total Pagado': row.payment_amount
                ? parseFloat(row.payment_amount).toFixed(2)
                : 0,
              'Total Pendiente': row.pending_amount
                ? parseFloat(row.pending_amount).toFixed(2)
                : 0,
              data: row,
            };
          });

           //let total = res.totalAmount.total;
           let total = roundNumber(res.allamount);
          let totalUsuarios = res.totalUsuarios;
          this.setState({ results: items, temp: items, total, totalUsuarios, loadingTable: false });
          this.renderResults();
        }
      },
      (error) => {
        this.setState({ loadingTable: false });
      }
    );
  }

  handleUpdate(e) {
    //e.preventDefault();

    //return true;
    if (this.state.value == 0) {
      Swal.fire('Error', 'Debe ingresar un valor mayor a 0.', 'error');
      return true;
    }

    this.setState({
      message: '',
      loading: true,
    });

    this.form.validateAll();

    if (
      this.checkBtn.context._errors.length === 0 &&
      !this.state.errors.template
    ) {
      this.onCloseModal('VaryingMdo');
      var user = AuthService.getCurrentUser();
      let select_date = Moment(this.state.paymentDate).format('YYYY-MM-DD');
      

      let formdata = new FormData();
      formdata.append('id_purchase', this.state.id_order);
      formdata.append('date_payment', select_date);
      formdata.append('reference', this.state.reference);
      formdata.append('value', this.state.value);
      formdata.append('voucher_image', this.state.file_image);

      // return true;

      ApiService.postPurchaseCharge(user.token, formdata).then(
        (res) => {

          if (res && res.status == 'success') {
            toast.success('Pago registrado!');
            this.getDataCollections();
            //this.getDataPurchaseCharge(this.state.id);
            this.clearInputs();
           
          } else {
            Swal.fire('Aviso!', res.message, 'error');
          }
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            openModal: false,
            loading: false,
            message: resMessage,
          });
        }
      );
    } else {
      this.setState({
        //openModal: false,
        loading: false,
      });
      return false;
    }
  }

  clearInputs() {
    this.setState({
      //delivery: "",
      reference: '',
      value: '',
      file_image: null,
      //paymentDate: "",
      loading: false,
      message: '',
    });
  }

  renderPagination(total, page, pageSize, onPageChange) {
    const totalPages = Math.ceil(total / pageSize);
    if (totalPages <= 1) return null;
    const from = (page - 1) * pageSize + 1;
    const to = Math.min(page * pageSize, total);
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '10px 16px', borderTop: '1px solid #f0f0f0',
        background: '#fafafa', fontSize: 13, color: '#666',
      }}>
        <span style={{ fontSize: 12, color: '#aaa' }}>
          {from}–{to} de {total}
        </span>
        <div style={{ display: 'flex', gap: 6 }}>
          <button
            disabled={page === 1}
            onClick={() => onPageChange(page - 1)}
            style={{
              border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
              background: page === 1 ? '#f4f4f4' : '#fff',
              color: page === 1 ? '#ccc' : '#333',
              cursor: page === 1 ? 'default' : 'pointer', fontSize: 13,
            }}
          >
            <i className='fa fa-chevron-left' />
          </button>
          <span style={{ padding: '4px 10px', fontSize: 13, color: '#555' }}>
            {page} / {totalPages}
          </span>
          <button
            disabled={page === totalPages}
            onClick={() => onPageChange(page + 1)}
            style={{
              border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
              background: page === totalPages ? '#f4f4f4' : '#fff',
              color: page === totalPages ? '#ccc' : '#333',
              cursor: page === totalPages ? 'default' : 'pointer', fontSize: 13,
            }}
          >
            <i className='fa fa-chevron-right' />
          </button>
        </div>
      </div>
    );
  }

  renderResults() {
    const { results, collectionsPage, collectionsSort } = this.state;
    if (results.length === 0) return '';

    const PAGE_SIZE = 50;
    const sorted = sortRows(results, collectionsSort);
    const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
    const page = Math.min(collectionsPage, totalPages);
    const paginated = sorted.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

    const headers = [
      { label: '#', key: 'Id' },
      { label: 'Usuario', key: 'Usuario' },
      { label: 'Embajador', key: 'Embajador' },
      { label: 'Fecha', key: 'Fecha' },
      { label: 'Estado', key: 'Estado Cobranza' },
      { label: 'Delivery', key: 'Delivery' },
      { label: 'Total', key: 'Total' },
      { label: 'Cash', key: 'Cash' },
      { label: 'Pagado', key: 'Total Pagado' },
      { label: 'Pendiente', key: 'Total Pendiente' },
      'Acción',
    ];

    return (
      <div style={{ border: '1px solid #ebebeb', borderRadius: 10, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #ebebeb' }}>
                {headers.map((h) => (
                  <SortableTh
                    key={typeof h === 'object' ? h.key : h}
                    header={h}
                    sort={collectionsSort}
                    onSort={this.handleCollectionsSort}
                  />
                ))}
              </tr>
            </thead>
            <tbody>
              {paginated.map((item) => {
                const row = { original: item };
                return (
                  <tr
                    key={item.Id}
                    style={{ borderBottom: '1px solid #f4f4f4' }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = '#f0faf4')}
                    onMouseLeave={(e) => (e.currentTarget.style.background = '')}
                  >
                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#27ae60', fontSize: 12, fontWeight: 600 }}>
                      #{item.Id}
                    </td>
                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                      <Link
                        to={`${process.env.PUBLIC_URL}/customer-profile/${item.id_user}`}
                        style={{ color: '#007bff', fontWeight: 500 }}
                      >
                        {item.Usuario}
                      </Link>
                    </td>
                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>
                      {item.Embajador}
                    </td>
                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                      {item.Fecha ? Moment(item.Fecha).format('DD MMM YYYY') : '—'}
                    </td>
                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                      <ChargeStatusBadge status={item['Estado Cobranza']} />
                    </td>
                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                      {fmtMoney(item.Delivery)}
                    </td>
                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', fontWeight: 700 }}>
                      {fmtMoney(item.Total)}
                    </td>
                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>
                      {fmtMoney(item.Cash)}
                    </td>
                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                      {fmtMoney(item['Total Pagado'])}
                    </td>
                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                      {fmtMoney(item['Total Pendiente'])}
                    </td>
                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                      {item.Estado === 'PROCESADO' ? (
                        <div style={{ display: 'flex' }}>
                          <a href="#" onClick={(e) => { e.preventDefault(); this.handlerDetails(row); }} title="Ver detalle">
                            <i className="fa fa-eye" style={{ width: 30, fontSize: 16, padding: 6, color: 'rgb(48 159 212)' }}></i>
                          </a>
                          <a href="#" onClick={(e) => { e.preventDefault(); this.handlerAcept(row); }} title="Aceptar">
                            <i className="fa fa-check-circle" style={{ width: 30, fontSize: 16, padding: 6, color: 'rgb(40, 167, 69)' }}></i>
                          </a>
                          <a href="#" onClick={(e) => { e.preventDefault(); this.handlerCancel(row); }} title="Rechazar">
                            <i className="fa fa-times-circle" style={{ width: 30, fontSize: 16, padding: 6, color: 'rgb(251 15 15)' }}></i>
                          </a>
                        </div>
                      ) : (
                        <div style={{ display: 'flex' }}>
                          <a href="#" onClick={(e) => { e.preventDefault(); this.handlerDetails(row); }} title="Ver detalle">
                            <i className="fa fa-eye" style={{ width: 30, fontSize: 16, padding: 6, color: 'rgb(48 159 212)' }}></i>
                          </a>
                          <Link to={`${process.env.PUBLIC_URL}/order-collections/${item.data.id}`} title="Ver pagos">
                            <i className="fa fa-money" style={{ width: 30, fontSize: 16, padding: 6, color: 'rgb(222 167 11)' }}></i>
                          </Link>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {this.renderPagination(results.length, page, PAGE_SIZE, (p) => this.setState({ collectionsPage: p }))}
      </div>
    );
  }

  renderDetailResults() {
    return this.state.detailResults.length === 0 ? (
      ''
    ) : (
      <VerDetailsOrderDatatable
        multiSelectOption={false}
        myData={this.state.detailResults}
        pageSize={this.state.detailResults.length + 1}
        pagination={true}
        class="-striped -highlight"
      />
    );
  }

  showImage(results) {
    // Aplicamos un fix si no devuelve una imagen
    let url_image = `${process.env.REACT_APP_URL_FILES}/images/products/`;
    for (let i = 0; i < results.length; i++) {
      results[i]['imagen'] = (
        <img
          src={url_image + results[i]['Product']['url']}
          style={{ width: 50, height: 50 }}
        />
      );
    }
    return results;
  }

  handlerDetails(data_row) {
    var user = AuthService.getCurrentUser();
    ApiService.getOrderDetails(user.token, data_row.original.Id).then(
      (res) => {
        if (res && res.status == 'success') {
          const items = this.showImage(res.data.Purchases_detail).map(function (
            row
          ) {
            return {
              id: row.id,
              Imagen: row.imagen,
              Nombre: row.Product.name,
              Precio: row.price,
              Cantidad: row.quantity,
              Total: row.total,
            };
          });

          var type_address = data_row.original.data.type_address
            ? data_row.original.data.type_address
            : '';
          var address = data_row.original.data.address
            ? data_row.original.data.address
            : '';
          var number = data_row.original.data.number
            ? data_row.original.data.number
            : '';
          var start_time = res.data.hour_programmed_start
            ? res.data.hour_programmed_start.toString()
            : '';
          var end_time = res.data.hour_programmed_end
            ? res.data.hour_programmed_end.toString()
            : '';

          this.setState({ detailResults: items });
          this.setState({ client: data_row.original.Usuario });
          this.setState({
            date: res.data.date_programmed ? res.data.date_programmed : '',
          });
          this.setState({
            hour:
              start_time && end_time
                ? start_time.slice(0, -3) + ' - ' + end_time.slice(0, -3)
                : '',
          });
          this.setState({ id_order: data_row.original.Id });
          this.setState({ total_order: data_row.original.Total });
          this.setState({
            address: type_address + ' ' + address + ' ' + number,
          });
          this.setState({
            cash: res.data.cash ? parseInt(res.data.cash, 10) : 0,
          });
          this.setState({
            district: data_row.original.data.district
              ? data_row.original.data.district
              : '',
          });
          this.setState({
            interior: data_row.original.data.interior
              ? data_row.original.data.interior
              : '',
          });
          this.setState({
            url_google: data_row.original.data.url_google
              ? data_row.original.data.url_google
              : '',
          });
          this.setState({
            delivery: res.data.delivery ? res.data.delivery : '0.00',
          });
          this.setState({
            state: data_row.original.data.status_charge
              ? data_row.original.data.status_charge
              : '',
          });
          this.setState({
            pending_payment: data_row.original.data.pending_amount
              ? data_row.original.data.pending_amount
              : '0.00',
          });
          this.setState({
            total_payment: data_row.original.data.payment_amount
              ? data_row.original.data.payment_amount
              : '0.00',
          });

          this.renderDetailResults();
          this.onOpenModal();
        }
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  handlerAcept(data_row) {
    Swal.fire({
      title: 'Confirmar',
      text: '¿Desea aceptar la orden nro ' + data_row.original.Id + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        var user = AuthService.getCurrentUser();
        let data = {
          idPurchase: data_row.original.Id,
          id_user: data_row.original.id_user,
        };
        ApiService.postAceptPurchase(user.token, data).then(
          (res) => {
            if (res && res.status == 'success') {
              Swal.fire('Hecho!', 'Orden Aceptada!', 'success');
              //toast.success("Orden Aceptada!");
              this.setState({ results: [] });
              this.getDataCollections();
            }
          },
          (error) => {
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
      }
    });
    //this.props.history.push("/edit-user/"+data_row.original.id);
    //window.location.reload();
  }

  handlerCancel(data_row) {
    Swal.fire({
      title: 'Confirmar',
      text: '¿Desea cancelar la orden nro ' + data_row.original.Id + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        var user = AuthService.getCurrentUser();
        let data = {
          idPurchase: data_row.original.Id,
          id_user: data_row.original.id_user,
        };
        ApiService.postCancelPurchase(user.token, data).then(
          (res) => {
            if (res && res.status == 'success') {
              Swal.fire('Hecho!', 'Orden Cancelada!', 'success');
              this.setState({ results: [] });
              this.getDataCollections();
            }
          },
          (error) => {
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
      }
    });
    //this.props.history.push("/edit-user/"+data_row.original.id);
    //window.location.reload();
  }

  onOpenModal = () => {
    this.setState({ openModal: true });
  };

  onCloseModal = () => {
    this.setState({ openModal: false });
  };

  componentWillReceiveProps() {
    this.getDataCollections();
  }

  render() {
    const { openModal } = this.state;
    return (
      <Fragment>
        <Breadcrumb title="Cobranzas" parent="Sales" />

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                <h5 style={{ marginLeft: "15px" }}>Pedidos por cobrar</h5>
                </div>
                <div className="card-body">
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
                    <div style={{
                      flex: '1 1 260px', background: '#fff', border: '1px solid #ebebeb',
                      borderRadius: 10, padding: 16,
                    }}>
                      <div style={{ fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: 4 }}>
                        Total por cobrar
                      </div>
                      <div style={{ fontSize: 24, fontWeight: 700, color: '#222' }}>
                        S/ {this.state.total}
                      </div>
                    </div>

                    <div style={{
                      flex: '2 1 320px', background: '#fff', border: '1px solid #ebebeb',
                      borderRadius: 10, padding: 16,
                    }}>
                      <div style={{ fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: 8 }}>
                        Principales deudores
                      </div>
                      {this.state.totalUsuarios.length === 0 ? (
                        <div style={{ color: '#ccc', fontSize: 13 }}>—</div>
                      ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                          {this.state.totalUsuarios.map((item, index) => (
                            <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                              <div style={{
                                width: 30, height: 30, borderRadius: '50%', flexShrink: 0,
                                background: DEBTOR_AVATAR_COLORS[index % DEBTOR_AVATAR_COLORS.length] + '22',
                                color: DEBTOR_AVATAR_COLORS[index % DEBTOR_AVATAR_COLORS.length],
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: 12, fontWeight: 700,
                              }}>
                                {initials(item.user.name, item.user.last_name)}
                              </div>
                              {item.id_user ? (
                                <Link
                                  to={`${process.env.PUBLIC_URL}/customer-profile/${item.id_user}`}
                                  style={{ color: '#007bff', fontWeight: 500, fontSize: 13, flexGrow: 1, minWidth: 0 }}
                                >
                                  {item.user.name} {item.user.last_name}
                                </Link>
                              ) : (
                                <span style={{ color: '#666', fontSize: 13, flexGrow: 1, minWidth: 0 }}>
                                  {item.user.name} {item.user.last_name}
                                </span>
                              )}
                              <span style={{ fontWeight: 600, color: '#333', whiteSpace: 'nowrap', fontSize: 13 }}>
                                S/ {item.total}
                              </span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  <div style={{ marginBottom: 16 }}>
                    <input
                      placeholder="Escriba para filtrar todas las columnas"
                      name="filter"
                      type="text"
                      autoComplete="off"
                      onInput={this.onChangeFilter}
                      style={{
                        width: '100%', borderRadius: 8, border: '1px solid #ddd',
                        padding: '8px 12px', fontSize: 14, margin: 0,
                      }}
                    />
                  </div>

                  <div id="batchDelete" className="transactions">
                    {this.state.loadingTable ? (
                      <div className="text-center py-5">
                        <span className="spinner-border text-primary" style={{ width: 40, height: 40 }} />
                        <p className="mt-3 text-muted">Cargando cobranzas...</p>
                      </div>
                    ) : this.renderResults()}
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal open={openModal} onClose={this.onCloseModal}>
          <div className="modal-header">
            <h5 className="modal-title f-w-600" id="exampleModalLabel2">
              Orden n° {this.state.id_order}
            </h5>
          </div>
          <div className="modal-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-body">
                     
                      <div className="clearfix">
                        
                      </div>
                      <div id="basicScenario" className="product-physical">
                        <div style={{ marginBottom: '15px' }}>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="row">
                                <div className="col-md-12">
                                  <label
                                    style={{
                                      marginRight: '5px',
                                      fontWeight: '700',
                                    }}
                                  >
                                    Cliente:
                                  </label>
                                  {this.state.client}
                                </div>
                                <div className="col-md-12">
                                  <label
                                    style={{
                                      marginRight: '5px',
                                      fontWeight: '700',
                                    }}
                                  >
                                    Total:
                                  </label>
                                  {this.state.total_order}
                                </div>
                                <div className="col-md-12">
                                  <label
                                    style={{
                                      marginRight: '5px',
                                      fontWeight: '700',
                                    }}
                                  >
                                    Delivery:
                                  </label>
                                  {this.state.delivery}
                                </div>
                                <div className="col-md-12">
                                  <label
                                    style={{
                                      marginRight: '5px',
                                      fontWeight: '700',
                                    }}
                                  >
                                    Cash:
                                  </label>
                                  {this.state.cash}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="row">
                                <div className="col-md-12">
                                  <label
                                    style={{
                                      marginRight: '5px',
                                      fontWeight: '700',
                                    }}
                                  >
                                    Estado:
                                  </label>
                                  {this.state.state}
                                </div>
                                <div className="col-md-12">
                                  <label
                                    style={{
                                      marginRight: '5px',
                                      fontWeight: '700',
                                    }}
                                  >
                                    Total Pagado:
                                  </label>
                                  {this.state.total_payment}
                                </div>
                                <div className="col-md-12">
                                  <label
                                    style={{
                                      marginRight: '5px',
                                      fontWeight: '700',
                                    }}
                                  >
                                    Total Pendiente:
                                  </label>
                                  {this.state.pending_payment}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <Form
                          id="frmCateg"
                          //onSubmit={this.handleUpdate}
                          encType="multipart/form-data"
                          method="POST"
                          ref={(c) => {
                            this.form = c;
                          }}
                        >
                          <div className="form-group row">
                            <div
                              className="col-md-5"
                              style={{ display: 'grid' }}
                            >
                              <label>Referencia</label>
                              <Input
                                name="name"
                                value={this.state.reference}
                                type="text"
                                className="form-control"
                                onChange={this.onChangeReference}
                                validations={[required]}
                                autoFocus
                              />
                            </div>
                            <div
                              className="col-md-5"
                              style={{ display: 'grid' }}
                            >
                              <label>Valor</label>
                              <Input
                                name="name"
                                value={this.state.value}
                                type="number"
                                className="form-control"
                                onChange={this.onChangeValue}
                                validations={[required]}
                                min="1"
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <div
                              className="col-md-5"
                              style={{ display: 'grid' }}
                            >
                              <label>Voucher</label>
                              <Input
                                name="url"
                                //value={this.state.file}
                                type="file"
                                className="form-control"
                                accept="image/*"
                                //validations={[required]}
                                //onChange={this.onChangeBackground}
                                //onChange={(e)=>this.handleFile(e)}
                                onChange={(e) => {
                                  this.setState(
                                    { file_image: e.target.files[0] },
                                    () => {
                                    }
                                  );
                                }}
                              />
                            </div>
                            <br />
                            <div
                              className="col-md-3"
                              style={{ display: 'grid' }}
                            >
                              <label>Fecha de Pago</label>
                              <DatePicker
                                selected={this.state.paymentDate}
                                onChange={this.handleChange}
                                locale="es"
                                dateFormat="dd/MM/yyyy"
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <div
                              className="col-md-3"
                              style={{ display: 'grid' }}
                            >
                              <a
                                //to={``}
                                className="btn btn-primary"
                                onClick={() => this.handleUpdate()}
                                style={{
                                  height: 'fit-content',
                                  marginTop: '2rem',
                                }}
                              >
                                {this.state.loading && (
                                  <span className="spinner-border spinner-border-sm"></span>
                                )}
                                <span>Guardar</span>
                              </a>
                            </div>
                          </div>

                          {this.state.message && (
                            <div className="form-group">
                              <div className="alert alert-danger" role="alert">
                                {this.state.message}
                              </div>
                            </div>
                          )}
                          <CheckButton
                            style={{ display: 'none' }}
                            ref={(c) => {
                              this.checkBtn = c;
                            }}
                          />
                        </Form>
                        {/* {this.renderResults()} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer"></div>
        </Modal>
      </Fragment>
    );
  }
}

export default VerCollectionList;
